export default __webpack_public_path__ + "static/media/shareWithTeam.299289d4.png";